import Title from "../Layout/Title";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

export default function OrgUsersTable({ orgId, pageData, setPageData }) {
  return (
    <>
      <Title>Users</Title>
      {!pageData.users[0] ? (
        <p>This org has no users</p>
      ) : (
        <Table size="small"  >
          <TableHead>
            <TableRow>
              <TableCell style={{ flex: 2 }}>Username</TableCell>
              <TableCell style={{ flex: 2 }}>Name</TableCell>
              <TableCell style={{ flex: 2 }}>Org</TableCell>
              <TableCell style={{ flex: 1 }}>Account type</TableCell>
              <TableCell style={{ flex: 1 }}>Account status</TableCell>
              <TableCell style={{ flex: 1 }} >Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody >
            {pageData.users.map((user) => (
              <TableRow key={user.keyId}>
                <TableCell style={{ flex: 2 }}>{user.user}</TableCell>
                <TableCell style={{ flex: 2 }} >{user.firstName + " " + user.lastName}</TableCell>
                <TableCell style={{ flex: 2}}>{user.company}</TableCell>
                <TableCell style={{ flex: 1 }}>{user.config}</TableCell>
                <TableCell style={{ flex: 1 }}>{user.stateName}</TableCell>
                <TableCell style={{ flex: 1 }}>{"-"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </>
  );
}
